import {HttpClient} from "../../service/httpClient/HttpClient";
import {setLoadingStateDispatch} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes} from "../../context/SnackBarContext";
import {convertPersianDateToUniversalDate} from "../../utils/TimeConvertor";
import {doDownloadFile} from "../../utils/DownloadHelper";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";

export class CashGroupService {

    constructor(fundID, token, snackbar, loading) {
        this.fundID = fundID;
        this.token = token;
        this.snackbar = snackbar;
        this.loading = loading;

        this.httpClient = new HttpClient()
    }


    getCashGroupsList(fundID, page, groupName = "", groupID = "", size = 20) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                "fund-presentation/funds/" + fundID + "/groups",
                this.httpClient.prepareUserAccessHeader(this.token),
                {
                    size: size,
                    page: page,
                    name: groupName,
                    "groupCode": groupID
                }
            ).then(response => {
                resolve(response)
            })
                .catch(reason => {
                    reject(reason)
                })
        })
    }


    getCashGroupInfoFromServer(fundID, groupID) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                "fund-presentation/funds/" + fundID + "/groups/" + groupID,
                this.httpClient.prepareUserAccessHeader(this.token)
            ).then(response => {
                resolve(response)
            }).catch(reason => {
                reject(reason)
            })
        })
    }

    addNewGroup(fundID, fundCode, groupName, enabled, clearFieldsData) {
        this.loading(setLoadingStateDispatch(true))

        this.httpClient.post(
            "fund-presentation/funds/" + fundID + "/groups",
            {
                "code": fundCode,
                "name": groupName,
                "enabled": enabled
            },
            this.httpClient.prepareUserAccessHeader(this.token)
        ).then(response => {

            clearFieldsData()
            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "گروه جدید با موفقیت افزوده شد!"))
            this.loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            this.handleError(reason, "خطا در افزودن گروه جدید!")
        })
    }


    updateCashGroupInfo(fundID, fundCode, groupID, groupName, enabled) {
        this.loading(setLoadingStateDispatch(true))

        this.httpClient.put(
            "fund-presentation/funds/" + fundID + "/groups/" + groupID,
            this.httpClient.prepareUserAccessHeader(this.token),
            {
                "name": groupName,
                "code": fundCode,
                "enabled": enabled
            }
        ).then(response => {
            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "بروزرسانی اطلاعات گروه با موفقیت انجام شد."))
            this.loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            this.handleError(reason, "خطا در بروزرسانی اطلاعات گروه!")
        })
    }

    handleError(reason, message) {
        if (reason.response.status === 409) {
            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "کد گروه تکراری می باشد!"))
            this.loading(setLoadingStateDispatch(false))
        } else {
            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, message))
            this.loading(setLoadingStateDispatch(false))
        }
    }

    getGroupReport(fundID, startDate, endDate, name, groupCode, page, size = 15) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-presentation/funds/${fundID}/groups/real-time-reports`,
                this.httpClient.prepareUserAccessHeader(this.token),
                {
                    name,
                    groupCode,
                    page,
                    size,
                    startDate: convertPersianDateToUniversalDate(startDate),
                    endDate: convertPersianDateToUniversalDate(endDate),
                }
            ).then(resolve).catch(reject)
        })
    }

    getGroupUsersList(fundID, groupId, page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-presentation/funds/${fundID}/groups/${groupId}/members/selections`,
                this.httpClient.prepareUserAccessHeader(this.token),
                {
                    page, size
                }
            ).then(resolve).catch(reject)
        })
    }

    updateGroupLeader(fundID, groupId, memberId) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `fund-presentation/funds/${fundID}/groups/${groupId}/leaders`,
                this.httpClient.prepareUserAccessHeader(this.token),
                {
                    memberId
                }
            ).then(resolve).catch(reject)
        })
    }

    downloadGroupReports(groupId, reportType,groupName) {
        this.loading(setLoadingStateDispatch(true))

        this.httpClient.getFile(
            `fund-presentation/funds/${this.fundID}/groups/${groupId}/reports/${reportType.id}`,
            this.httpClient.prepareUserAccessHeader(this.token)
        ).then(response => {

            doDownloadFile(response, `گزارش وضعیت گروه ${groupName}`, reportType.type)

            this.loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            ServerErrorHandler(
                reason,
                "خطا در دریافت فایل گزارش",
                this.snackbar,
                this.loading
            )
        })
    }

    getGroupReportSummation(fundID, startDate, endDate, name, groupCode) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-presentation/funds/${fundID}/groups/real-time-reports/summations`,
                this.httpClient.prepareUserAccessHeader(this.token),
                {
                    name,
                    groupCode,
                    startDate: convertPersianDateToUniversalDate(startDate),
                    endDate: convertPersianDateToUniversalDate(endDate),
                }
            ).then(resolve).catch(reject)
        })
    }
}